/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Hide new variables",
  "description": "Do not automatically create monitors for newly created variables or lists.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "tags": [],
  "dynamicDisable": true,
  "dynamicEnable": true
};
export default manifest;
